import axios from "@/utils/axios.js";
// import PageOptions from "@/models/PageOptions";

/**
 * Получение списка пассажиров
 */
function getPassengers(perPage, currentPage, sort, search) {
  return new Promise((resolve, reject) => {
    axios
      .get(`passengers?${sort ? `&sort=${sort}` : ''}${search ? `&search[All]=${search}` : ''}&per-page=${perPage}&page=${currentPage}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * Получение пассажира
 */
function getPassenger(id) {
  return new Promise((resolve, reject) => {
    axios
      .get(`passengers/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function getPassengersSearch(value) {
  return new Promise((resolve, reject) => {
    axios
        .get(`passengers?search[name]=${value}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
  });
}

/**
 * Создание пассажира
 * @param {String} name
 * @param {String} surname
 * @param {String} patronymic
 * @param {String} email
 * @param {Boolean} sex
 * @param {String} birthday
 * @param {String} citizenship
 * @param {String} phone
 * @param {Number} document_id
 * @param {String} document_number
 * @param {String} document_validity
 * @param {Number} department_id
 * @param {Number} filiation_id
 * @param {Boolean} is_vip
 */
function createPassenger(
  name,
  surname,
  patronymic,
  email, // TODO: изменить на login когда бэкенд будет обновлен
  sex,
  birthday,
  citizenship,
  phone,
  document_id,
  document_number,
  document_validity,
  department_id,
  filiation_id,
  is_vip
) {
  const passengerData = {
    name,
    surname,
    patronymic,
    sex,
    email, // TODO: изменить на login когда бэкенд будет обновлен
    birthday,
    citizenship,
    phone,
    document_id,
    document_number,
    document_validity,
    department_id,
    filiation_id,
    is_vip
  };
  return new Promise((resolve, reject) => {
    axios
      .post("passengers", passengerData)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * Редактирование пассжира
 * @param {Number} passengerId
 * @param {String} name
 * @param {String} surname
 * @param {String} patronymic
 * @param {String} email
 * @param {Boolean} sex
 * @param {String} birthday
 * @param {String} citizenship
 * @param {Number} document_id
 * @param {String} document_number
 * @param {String} document_validity
 * @param {String} phone
 * @param {Number} department_id
 * @param {Number} filiation_id
 * @param {Boolean} is_vip
 */
function updatePassenger(
  passengerId,
  name,
  surname,
  patronymic,
  email, // TODO: изменить на login когда бэкенд будет обновлен
  sex,
  birthday,
  citizenship,
  document_id,
  document_number,
  document_validity,
  phone,
  department_id,
  filiation_id,
  is_vip
) {
  const passengerData = {
    name,
    surname,
    patronymic,
    email, // TODO: изменить на login когда бэкенд будет обновлен
    sex,
    birthday,
    citizenship,
    document_id,
    document_number,
    document_validity,
    phone,
    department_id,
    filiation_id,
    is_vip
  };

  return new Promise((resolve, reject) => {
    axios
      .put(`passengers/${passengerId}`, passengerData)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * Удаление пассажира
 */
function deletePassenger(id) {
  return new Promise((resolve, reject) => {
    axios
      .delete(`passengers/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * Удаление пассажиров
 */
function deletePassengers(ids) {
  return new Promise((resolve, reject) => {
    axios
      .delete(`passengers`, { data: { users: ids } })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export {
  getPassengers,
  getPassenger,
  createPassenger,
  updatePassenger,
  deletePassenger,
  deletePassengers,
};
